import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsideLook } from './components/InsideLook';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="w-full bg-background text-foreground" data-id="element-0" data-mp="28sbb5328r364">
      <MetaPixel data-id="element-1" data-mp="23u9u0nodldxa" />
      <UtmifyScript data-id="element-2" data-mp="23utbk3a460as" />
      <CountdownBar data-id="element-3" data-mp="23t8g8bfz6dbv" />
      <main data-id="element-4" data-mp="3ijxsgzk2wgo4">
        <Hero data-id="element-5" data-mp="3ikh829m9asyz" />
        <StatsBar data-id="element-6" data-mp="3iiwdijzxza14" />
        <Difference data-id="element-7" data-mp="3ijfx0558q6h9" />
        <WhatsInside data-id="element-8" data-mp="3ihv048vgebg8" />
        <InsideLook data-id="element-9" data-mp="3mlj6wpc9h30f" />
        <Bonuses data-id="element-10" data-mp="3mkrdnl64zhdb" />
        <Offer data-id="element-11" data-mp="3mk8710lxsfel" />
        <Guarantee data-id="element-12" data-mp="3mjzpgvevclx2" />
        <Testimonials data-id="element-13" data-mp="3mj6ipufwtwex" />
        <Faq data-id="element-14" data-mp="3rcj8i7wbs999" />
        <FinalCta data-id="element-15" data-mp="3rbzmaezn6ypf" />
      </main>
      <Footer data-id="element-16" data-mp="3rcswjpxt86cb" />
      <PurchaseToast data-id="element-17" data-mp="3recdzjv7cnfo" />
    </div>;
}